// extracted by mini-css-extract-plugin
export var csatScore = "_fy-5";
export var header = "_fy-1";
export var panelWrapper = "_fy-2";
export var postPreview = "_fy-3";
export var rightContent = "_fy-0";
export var wrappingText = "_fy-4";